/* ============================================================
   moon-phase.js  —  Spark Store Moon Phase Poster
   ============================================================ */
(function () {
  'use strict';

  /* ── CONFIG ───────────────────────────────────────────── */
  var MOON_IMG_URL = 'https://cdn.shopify.com/s/files/1/0593/4894/2931/files/moon-png-44668.png?v=1779103846';

  var SIZE_CONFIG = {
    '20*30': { wCm: 20, hCm: 30 },
    '30*40': { wCm: 30, hCm: 40 },
    '40*50': { wCm: 40, hCm: 50 },
    '50*70': { wCm: 50, hCm: 70 },
  };
  var DEFAULT_SIZE = '20*30';
  var MIN_DPI      = 150;
  var SYNODIC      = 29.53058885;

  var KNOWN_NEW_MS = Date.UTC(2025, 2, 29, 10, 58, 0);

  var BG_COLORS = {
    '0a0a0f': { label: 'Deep Black' },
    '080c1a': { label: 'Dark Navy'  },
    '060d1f': { label: 'Midnight'   },
  };
  var PHASE_ICONS = {
    'New Moon':        '🌑',
    'Waxing Crescent': '🌒',
    'First Quarter':   '🌓',
    'Waxing Gibbous':  '🌔',
    'Full Moon':       '🌕',
    'Waning Gibbous':  '🌖',
    'Last Quarter':    '🌗',
    'Waning Crescent': '🌘',
  };

  /* ── STATE ────────────────────────────────────────────── */
  var state = { bg: '0a0a0f', selectedOptions: {}, currentSize: DEFAULT_SIZE, phase: null };
  var moonImg = null, moonLoaded = false, drawRaf = null;
  function g(id) { return document.getElementById(id); }

  /* ── SPINNER ──────────────────────────────────────────── */
  function showSpinner(btn) {
    var orig = btn.innerHTML;
    btn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:8px;">' +
      '<svg width="16" height="16" viewBox="0 0 16 16" style="animation:mp-spin 0.7s linear infinite;flex-shrink:0;">' +
      '<circle cx="8" cy="8" r="6" fill="none" stroke="rgba(255,255,255,0.3)" stroke-width="2"/>' +
      '<path d="M8 2 A6 6 0 0 1 14 8" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>' +
      '<span id="mp-spin-label">Working…</span></span>';
    btn.disabled = true; btn.dataset.sparkBusy = '1';
    return {
      label:   function(t) { var l = g('mp-spin-label'); if(l) l.textContent = t; },
      restore: function()  { btn.innerHTML = orig; btn.disabled = false; delete btn.dataset.sparkBusy; },
    };
  }

  /* ── CANVAS RESIZE ────────────────────────────────────── */
  function resizeCanvas() {
    var canvas = g('mp-poster'); if (!canvas) return;
    var cfg = SIZE_CONFIG[state.currentSize] || SIZE_CONFIG[DEFAULT_SIZE];
    canvas.width  = 800;
    canvas.height = Math.round(800 * cfg.hCm / cfg.wCm);
    canvas.style.width  = '100%';
    canvas.style.height = 'auto';
  }

  /* ── INIT ─────────────────────────────────────────────── */
  function init() {
    if (!g('mp-form')) return;
    if (!g('mp-spin-style')) {
      var st = document.createElement('style');
      st.id = 'mp-spin-style';
      st.textContent = '@keyframes mp-spin{to{transform:rotate(360deg)}}';
      document.head.appendChild(st);
    }

    moonImg = new Image();
    moonImg.crossOrigin = 'anonymous';
    moonImg.onload  = function() { moonLoaded = true;  scheduleDraw(); };
    moonImg.onerror = function() {
      var fb = new Image();
      fb.onload  = function() { moonImg = fb; moonLoaded = true;  scheduleDraw(); };
      fb.onerror = function() { moonLoaded = false; scheduleDraw(); };
      fb.src = MOON_IMG_URL;
    };
    moonImg.src = MOON_IMG_URL;

    document.querySelectorAll('.mp-pill.active[data-option]').forEach(function(p) {
      state.selectedOptions[p.dataset.option] = p.dataset.value;
      if (p.dataset.value in SIZE_CONFIG) state.currentSize = p.dataset.value;
    });

    bindEvents();
    resizeCanvas();
    resolveVariant();
    scheduleDraw();
  }

  /* ── MOON PHASE ALGORITHM ─────────────────────────────── */
  function getMoonPhase(utcMs) {
    var diff = (utcMs - KNOWN_NEW_MS) / 86400000;
    var age  = ((diff % SYNODIC) + SYNODIC) % SYNODIC;
    var illum = (1 - Math.cos(2 * Math.PI * age / SYNODIC)) / 2;
    var name;
    if      (age <  1.00) name = 'New Moon';
    else if (age <  7.38) name = 'Waxing Crescent';
    else if (age <  9.22) name = 'First Quarter';
    else if (age < 14.77) name = 'Waxing Gibbous';
    else if (age < 16.61) name = 'Full Moon';
    else if (age < 22.15) name = 'Waning Gibbous';
    else if (age < 23.99) name = 'Last Quarter';
    else if (age < 29.53) name = 'Waning Crescent';
    else                  name = 'New Moon';
    return { age: age, illum: illum, name: name };
  }

  /* ── EVENTS ───────────────────────────────────────────── */
  function bindEvents() {
    ['mp-date','mp-title','mp-subtitle'].forEach(function(id) {
      var el = g(id); if (el) el.addEventListener('input', onInputChange);
    });

    var bgRow = g('mp-bg-row');
    if (bgRow) bgRow.addEventListener('click', function(e) {
      var btn = e.target.closest('.mp-pill'); if (!btn) return;
      document.querySelectorAll('#mp-bg-row .mp-pill').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      state.bg = btn.dataset.bg;
      scheduleDraw();
    });

    document.querySelectorAll('.mp-pill[data-option]').forEach(function(pill) {
      pill.addEventListener('click', function() {
        if (this.classList.contains('unavailable')) return;
        var opt = this.dataset.option;
        document.querySelectorAll('.mp-pill[data-option="'+opt+'"]').forEach(function(p) { p.classList.remove('active'); });
        this.classList.add('active');
        state.selectedOptions[opt] = this.dataset.value;
        if (this.dataset.value in SIZE_CONFIG) { state.currentSize = this.dataset.value; resizeCanvas(); }
        resolveVariant(); scheduleDraw();
      });
    });

    var form = g('mp-form');
    if (form) form.addEventListener('submit', handleSubmit, true);
  }

  function onInputChange() { updatePhaseBadge(); scheduleDraw(); }

  /* ── PHASE BADGE ──────────────────────────────────────── */
  function updatePhaseBadge() {
    var dateStr = g('mp-date') && g('mp-date').value;
    var badge   = g('mp-phase-badge');
    if (!dateStr || !badge) { if (badge) badge.style.display = 'none'; state.phase = null; return; }
    var p = dateStr.split('-');
    var phase = getMoonPhase(Date.UTC(+p[0], +p[1]-1, +p[2], 12));
    state.phase = phase;
    var icon = g('mp-phase-icon'), name = g('mp-phase-name'), detail = g('mp-phase-detail');
    if (icon)   icon.textContent   = PHASE_ICONS[phase.name] || '🌙';
    if (name)   name.textContent   = phase.name;
    if (detail) detail.textContent = Math.round(phase.illum * 100) + '% illuminated · Day ' + Math.round(phase.age);
    badge.style.display = 'flex';
  }

  /* ── VARIANT ──────────────────────────────────────────── */
  function resolveVariant() {
    var variants = window.mpVariants; if (!variants) return;
    var vi = g('mp-variant-id'), pd = g('mp-price'), pc = g('mp-price-compare'), ab = g('mp-atc-btn');
    var names = Object.keys(state.selectedOptions), found = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (names.every(function(n, idx) { return v['option'+(idx+1)] === state.selectedOptions[n]; })) { found = v; break; }
    }
    if (!found) return;
    if (vi) vi.value = found.id;
    if (pd) pd.textContent = (found.price/100).toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:0})+' EGP';
    if (pc) {
      if (found.compareAt && found.compareAt > found.price) {
        pc.textContent = (found.compareAt/100).toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:0})+' EGP';
        pc.style.display = '';
      } else { pc.style.display = 'none'; }
    }
    if (ab && !ab.dataset.sparkBusy) {
      ab.disabled = !found.available;
      ab.textContent = found.available ? '🛒 Add to Cart' : 'Out of Stock';
    }
  }

  /* ── DRAW SCHEDULER ───────────────────────────────────── */
  function scheduleDraw() {
    if (drawRaf) cancelAnimationFrame(drawRaf);
    drawRaf = requestAnimationFrame(drawPoster);
  }

  /* ── STARS ────────────────────────────────────────────── */
  function drawStars(ctx, W, H) {
    var s = 31337;
    function r() { s = (s*1664525+1013904223)&0xffffffff; return (s>>>0)/4294967296; }
    for (var i = 0; i < 220; i++) {
      var x=r()*W, y=r()*H*0.88, rad=r()*0.85+0.2, a=r()*0.55+0.08;
      ctx.beginPath(); ctx.arc(x,y,rad,0,Math.PI*2);
      ctx.fillStyle='rgba(255,255,255,'+a.toFixed(2)+')'; ctx.fill();
    }
    for (var j = 0; j < 14; j++) {
      var x2=r()*W, y2=r()*H*0.88, r2=r()*0.55+0.95, a2=r()*0.3+0.6;
      ctx.beginPath(); ctx.arc(x2,y2,r2,0,Math.PI*2);
      ctx.fillStyle='rgba(255,255,255,'+a2.toFixed(2)+')'; ctx.fill();
    }
  }

  /* ── DRAW MOON ────────────────────────────────────────── */
  function drawMoon(ctx, cx, cy, radius, phase) {
    var illum      = phase.illum;
    var normalized = phase.age / SYNODIC;
    var isWaxing   = normalized < 0.5;

    var D  = Math.ceil(radius * 2) + 2;
    var r  = D / 2;
    var ox = r, oy = r;

    var moonOff = document.createElement('canvas');
    moonOff.width = D; moonOff.height = D;
    var mCtx = moonOff.getContext('2d');

    if (moonLoaded && moonImg) {
      var IMG_W = 2000, IMG_H = 1955, MOON_W = 1742;
      var sc = (IMG_W / MOON_W);
      var dw = sc * r * 2;
      var dh = (IMG_H / IMG_W) * dw;
      mCtx.drawImage(moonImg, ox - sc*r, oy - (IMG_H/IMG_W)*sc*r, dw, dh);
    } else {
      var fb = mCtx.createRadialGradient(ox-r*0.2, oy-r*0.2, r*0.05, ox, oy, r);
      fb.addColorStop(0,'#d8d8e0'); fb.addColorStop(0.5,'#a0a0b0'); fb.addColorStop(1,'#606070');
      mCtx.fillStyle = fb; mCtx.fillRect(0, 0, D, D);
    }

    if (illum > 0.99) {
      blitCircle(ctx, moonOff, cx, cy, r);
      addGlow(ctx, cx, cy, radius);
      return;
    }

    var shadowOff = document.createElement('canvas');
    shadowOff.width = D; shadowOff.height = D;
    var sCtx = shadowOff.getContext('2d');

    var SHADOW_R = 38, SHADOW_G = 42, SHADOW_B = 68;
    var cosVal = Math.cos(normalized * Math.PI * 2);
    var a = Math.abs(cosVal) * r;

    var imgData = sCtx.createImageData(D, D);
    var data    = imgData.data;

    for (var py = 0; py < D; py++) {
      var dy = py - oy;
      var dyy = dy * dy;
      if (dyy > r * r) continue;
      var circleX = Math.sqrt(r * r - dyy);
      var tFrac = 1 - dyy / (r * r);
      var tX    = a * Math.sqrt(tFrac);
      var shadowXStart, shadowXEnd;
      if (isWaxing) {
        if (illum < 0.5) { shadowXStart = ox - circleX; shadowXEnd = ox + tX; }
        else             { shadowXStart = ox - circleX; shadowXEnd = ox - tX; }
      } else {
        if (illum < 0.5) { shadowXStart = ox - tX; shadowXEnd = ox + circleX; }
        else             { shadowXStart = ox + tX; shadowXEnd = ox + circleX; }
      }
      var xStart = Math.max(0, Math.round(shadowXStart));
      var xEnd   = Math.min(D - 1, Math.round(shadowXEnd));
      for (var px = xStart; px <= xEnd; px++) {
        var idx = (py * D + px) * 4;
        data[idx]     = SHADOW_R;
        data[idx + 1] = SHADOW_G;
        data[idx + 2] = SHADOW_B;
        data[idx + 3] = 255;
      }
    }
    sCtx.putImageData(imgData, 0, 0);

    mCtx.globalCompositeOperation = 'multiply';
    mCtx.drawImage(shadowOff, 0, 0);
    mCtx.globalCompositeOperation = 'source-over';

    var penW = Math.max(2, r * 0.05);
    var termCentreX = isWaxing
      ? (illum < 0.5 ? ox + a : ox - a)
      : (illum < 0.5 ? ox - a : ox + a);
    var pg = mCtx.createLinearGradient(termCentreX - penW, 0, termCentreX + penW, 0);
    if (isWaxing) {
      pg.addColorStop(0, 'rgba(38,42,68,0.55)'); pg.addColorStop(1, 'rgba(38,42,68,0)');
    } else {
      pg.addColorStop(0, 'rgba(38,42,68,0)'); pg.addColorStop(1, 'rgba(38,42,68,0.55)');
    }
    mCtx.fillStyle = pg; mCtx.fillRect(0, 0, D, D);

    blitCircle(ctx, moonOff, cx, cy, r);
    addGlow(ctx, cx, cy, radius);
  }

  function blitCircle(ctx, offscreen, cx, cy, r) {
    ctx.save();
    ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); ctx.clip();
    ctx.drawImage(offscreen, cx - r, cy - r);
    ctx.restore();
  }

  function addGlow(ctx, cx, cy, radius) {
    var gr = ctx.createRadialGradient(cx, cy, radius*0.94, cx, cy, radius*1.35);
    gr.addColorStop(0,   'rgba(200,215,255,0.10)');
    gr.addColorStop(0.5, 'rgba(170,190,255,0.04)');
    gr.addColorStop(1,   'rgba(100,130,255,0.00)');
    ctx.beginPath(); ctx.arc(cx, cy, radius*1.35, 0, Math.PI*2);
    ctx.fillStyle = gr; ctx.fill();
  }

  /* ── POSTER DRAW ──────────────────────────────────────── */
  function drawPoster() {
    drawRaf = null;
    var canvas = g('mp-poster'); if (!canvas) return;
    var ctx = canvas.getContext('2d');
    // BUG FIX: live preview always shows watermark — pass true
    renderScene(ctx, canvas.width, canvas.height, true);
  }

  // BUG FIX: renderScene no longer calls drawWatermark internally.
  // The withWatermark parameter is passed through from the caller,
  // so the print file (withWatermark=false) stays clean.
  function renderScene(ctx, W, H, withWatermark) {
    var dateStr  = g('mp-date')     && g('mp-date').value;
    var titleVal = g('mp-title')    && g('mp-title').value.trim();
    var subVal   = g('mp-subtitle') && g('mp-subtitle').value.trim();

    // BUG FIX: validate mandatory title field — use fallback only for preview display
    var titleDisplay = (titleVal || 'THE DAY WE MET').toUpperCase();

    ctx.fillStyle = '#' + state.bg;
    ctx.fillRect(0, 0, W, H);

    var vig = ctx.createRadialGradient(W/2, H/2, H*0.2, W/2, H/2, H*0.82);
    vig.addColorStop(0, 'rgba(0,0,0,0)'); vig.addColorStop(1, 'rgba(0,0,0,0.55)');
    ctx.fillStyle = vig; ctx.fillRect(0, 0, W, H);

    drawStars(ctx, W, H);

    var phase = state.phase || { age: 14.5, illum: 1, name: 'Full Moon' };
    if (dateStr && !state.phase) {
      var p = dateStr.split('-');
      phase = getMoonPhase(Date.UTC(+p[0], +p[1]-1, +p[2], 12));
    }
    drawMoon(ctx, W/2, H*0.37, W*0.37, phase);

    ctx.strokeStyle = 'rgba(255,255,255,0.13)';
    ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(W*0.2, H*0.728); ctx.lineTo(W*0.8, H*0.728); ctx.stroke();

    ctx.fillStyle    = 'rgba(255,255,255,0.92)';
    ctx.textAlign    = 'center';
    ctx.textBaseline = 'middle';
    ctx.font         = '400 ' + Math.round(W*0.062) + 'px "Jost",sans-serif';
    ctx.fillText(titleDisplay, W/2, H*0.786);

    if (dateStr) {
      var dp = dateStr.split('-');
      var mo = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      ctx.fillStyle = 'rgba(255,255,255,0.38)';
      ctx.font      = '300 ' + Math.round(W*0.032) + 'px "Jost",sans-serif';
      ctx.fillText(mo[+dp[1]-1]+' '+parseInt(dp[2])+', '+dp[0], W/2, H*0.844);
    }
    if (subVal) {
      ctx.fillStyle = 'rgba(255,255,255,0.22)';
      ctx.font      = '200 ' + Math.round(W*0.027) + 'px "Jost",sans-serif';
      ctx.fillText(subVal.toUpperCase(), W/2, H*0.89);
    }

    // BUG FIX: watermark is now conditional — never drawn on the clean print file
    if (withWatermark) drawWatermark(ctx, W, H);
  }

  /* ── WATERMARK ────────────────────────────────────────── */
  function drawWatermark(ctx, W, H) {
    ctx.save();
    var fontSize = Math.max(8, Math.round(W * 0.022));
    ctx.font = fontSize + 'px sans-serif';
    ctx.fillStyle = 'rgba(255,255,255,0.09)';
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    var text = 'SPARK PREVIEW';
    var angle = -Math.PI / 6;
    var textW = ctx.measureText(text).width;
    var stepX = textW + fontSize * 1.5;
    var stepY = fontSize * 2.5;
    ctx.translate(W/2, H/2); ctx.rotate(angle);
    var d = Math.ceil(Math.sqrt(W*W + H*H));
    for (var row = -d; row < d; row += stepY)
      for (var col = -d; col < d; col += stepX)
        ctx.fillText(text, col, row);
    ctx.restore();
  }

  /* ── RENDER TO FILE ───────────────────────────────────── */
  function renderToFile(withWatermark, W, H, callback) {
    var off = document.createElement('canvas');
    off.width = W; off.height = H;
    var ctx = off.getContext('2d');
    // BUG FIX: pass withWatermark into renderScene instead of calling drawWatermark separately
    renderScene(ctx, W, H, withWatermark);
    off.toBlob(callback, 'image/jpeg', withWatermark ? 0.65 : 0.93);
  }

  /* ── SUBMIT ───────────────────────────────────────────── */
  function handleSubmit(e) {
    e.preventDefault(); e.stopImmediatePropagation();
    var dateStr  = g('mp-date')  && g('mp-date').value;
    var titleVal = g('mp-title') && g('mp-title').value.trim();
    // BUG FIX: validate mandatory fields
    if (!dateStr)  { showError('Please enter a date before adding to cart.'); return; }
    if (!titleVal) { showError('Please enter a title before adding to cart.'); return; }
    var vi = g('mp-variant-id');
    if (!vi || !vi.value) { showError('Please select all options.'); return; }
    var atcBtn = g('mp-atc-btn');
    if (atcBtn && atcBtn.dataset.sparkBusy) return;
    hideError(); syncProps();
    var spin = showSpinner(atcBtn);
    spin.label('Rendering poster…');
    var cfg   = SIZE_CONFIG[state.currentSize] || SIZE_CONFIG[DEFAULT_SIZE];
    var CM    = 1 / 2.54;
    var fullW = Math.round(cfg.wCm * CM * MIN_DPI);
    var fullH = Math.round(cfg.hCm * CM * MIN_DPI);
    renderToFile(false, fullW, fullH, function(cleanBlob) {
      if (!cleanBlob) { showError('Could not render poster.'); spin.restore(); return; }
      var cleanFile = new File([cleanBlob], 'moon-phase-poster.jpg', {type:'image/jpeg'});
      renderToFile(true, 220, Math.round(220*cfg.hCm/cfg.wCm), function(prevBlob) {
        var previewFile = prevBlob ? new File([prevBlob], 'moon-phase-preview.jpg', {type:'image/jpeg'}) : null;
        var hp = g('mp-hidden-print'), pp = g('mp-hidden-preview');
        try { var dt1 = new DataTransfer(); dt1.items.add(cleanFile); hp.files = dt1.files; }
        catch(err) { showError('Upload not supported. Please use Chrome or Safari.'); spin.restore(); return; }
        if (previewFile && pp) { try { var dt2 = new DataTransfer(); dt2.items.add(previewFile); pp.files = dt2.files; } catch(ex){} }
        spin.label('Uploading…');
        fetch('/cart/add.js', {method:'POST', credentials:'same-origin', body:new FormData(g('mp-form'))})
          .then(function(res) {
            if (!res.ok) return res.json().then(function(d){ throw new Error(d.description||d.message||'Cart error'); });
            return res.json();
          })
          .then(function() {
            spin.label('Added! ✓');
            setTimeout(function(){ spin.restore(); }, 1200);
            resetForm();
            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {source:'moon-phase-poster'});
              setTimeout(function(){
                var cd = document.querySelector('cart-drawer');
                if (cd) { cd.classList.remove('is-empty'); if (cd.open) cd.open(); }
              }, 300);
            } else {
              var ci = document.querySelector('#cart-icon-bubble,[data-cart-toggle],.js-drawer-open-right');
              if (ci) ci.click();
            }
          })
          .catch(function(err){ showError(err.message||'Something went wrong.'); spin.restore(); });
      });
    });
  }

  /* ── SYNC PROPS ───────────────────────────────────────── */
  function syncProps() {
    var dateStr  = g('mp-date')     && g('mp-date').value;
    var titleVal = g('mp-title')    && g('mp-title').value.trim();
    var subVal   = g('mp-subtitle') && g('mp-subtitle').value.trim();
    var phase    = state.phase;
    var bgLabel  = BG_COLORS[state.bg] ? BG_COLORS[state.bg].label : state.bg;
    var set = function(id, val){ var el=g(id); if(el) el.value=val; };
    if (dateStr) {
      var dp = dateStr.split('-');
      var mo = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      set('mp-prop-date', mo[+dp[1]-1]+' '+parseInt(dp[2])+', '+dp[0]);
    }
    set('mp-prop-phase',    phase ? phase.name+' ('+Math.round(phase.illum*100)+'% illuminated)' : '');
    set('mp-prop-title',    titleVal || 'THE DAY WE MET');
    set('mp-prop-subtitle', subVal   || '');
    set('mp-prop-bg',       bgLabel);
  }

  /* ── RESET ────────────────────────────────────────────── */
  function resetForm() {
    ['mp-date','mp-title','mp-subtitle'].forEach(function(id){ var el=g(id); if(el) el.value=''; });
    state.phase = null;
    var badge = g('mp-phase-badge'); if (badge) badge.style.display = 'none';
    try{ var hp=g('mp-hidden-print');   if(hp) hp.files=new DataTransfer().files; }catch(e){}
    try{ var pp=g('mp-hidden-preview'); if(pp) pp.files=new DataTransfer().files; }catch(e){}
    scheduleDraw();
  }

  /* ── HELPERS ──────────────────────────────────────────── */
  function showError(msg) {
    var el=g('mp-error'); if(!el) return;
    el.textContent=msg; el.classList.add('visible');
    el.scrollIntoView({behavior:'smooth',block:'nearest'});
  }
  function hideError() { var el=g('mp-error'); if(el) el.classList.remove('visible'); }

  /* ── BOOT ─────────────────────────────────────────────── */
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();